<template>
    <div class="reposicion-config-card">
        <div class="reposicion-header-row">
            <input-search class="reposicion-action-search" @getData="getSearch" />
            <div class="reposicion-actions-row">
                <button
                    class="btn btn-sm bg-white fw-400"
                    style="
                        color: black !important;
                        border: 1px solid black !important
                    "
                    @click="viewConfig('','config-reposicion-options','Costo de reposición','Actualizar costo de reposición para varios productos')"
                >
                    Configuración en lote
                </button>
            </div>
        </div>

        <div class="reposicion-table-info-row">
            <span
                class="reposicion-total-count"
                v-if="totalCount > 0 && !loading"
            >
                Total: {{ totalCount }}
            </span>
        </div>

        <div class="table-responsive border" v-if="products.length > 0 || loading">
            <placeholder v-if="loading" :type="'table'" :count="3"/>
            <table class="reposicion-table w-100" v-else>
                <thead>
                    <tr>
                        <th v-if="isColumnVisible('sku')">{{ getColumnLabel('sku') }}</th>
                        <th v-if="isColumnVisible('long_name')">{{ getColumnLabel('long_name') }}</th>
                        <th v-if="isColumnVisible('store_name')">{{ getColumnLabel('store_name') }}</th>
                        <th v-if="isColumnVisible('cost_price')" class="editable-header">{{ getColumnLabel('cost_price') }}</th>
                        <th v-if="isColumnVisible('cost_updated_at')">{{ getColumnLabel('cost_updated_at') }}</th>
                        <th v-if="isColumnVisible('actions')">{{ getColumnLabel('actions') }}</th>
                    </tr>
                </thead>
                <tbody>
                    <tr v-for="(product, index) in products" :key="index">
                        <td v-if="isColumnVisible('sku')">
                            <span class="reposicion-sku-badge">{{ product.sku }}</span>
                        </td>
                        <td v-if="isColumnVisible('long_name')">{{ product.long_name || (product.product ? product.product.long_name : '') }}</td>
                        <td v-if="isColumnVisible('store_name')">{{ product.store_name || '—' }}</td>
                        <td v-if="isColumnVisible('cost_price')" class="col-highlight">{{ clientMoney }} {{ formatCost(product) }}</td>
                        <td v-if="isColumnVisible('cost_updated_at')">{{ formatDate(product.cost_updated_at) }}</td>
                        <td v-if="isColumnVisible('actions')">
                            <div class="d-flex flex-column gap-1">
                                <span
                                    @click="viewConfig(product,'config-reposicion-one','Costo de reposición','Actualizar costo de reposición')"
                                >
                                    <img class="cursor-pointer" src="/icons/pencil-margin.svg" alt="Editar"/>
                                </span>
                            </div>
                        </td>
                    </tr>
                </tbody>
            </table>
        </div>

        <!-- No data message -->
        <div v-if="products.length <= 0 && !loading" class="p-4 bg-white rounder-8 border border-1 text-center">
            <h4 class="fw-400 size-18 text-secondary">No existe información para mostrar</h4>
        </div>

        <PaginationControls
            v-if="totalCount > 0"
            :current-page="currentPage"
            :total-count="totalCount"
            :page-size="pageSize"
            @change-page="$emit('change-page', $event)"
            @change-page-size="$emit('change-page-size', $event)"
        />
    </div>
</template>

<script>
import { mapGetters } from 'vuex'
import inputSearch from '@/components/inputSearch.vue';
import Placeholder from "../../../../../components/loadings/placeholder.vue";
import PaginationControls from "../../../../../components/PaginationControls.vue";
import configsRecTableMixin from '../mixins/configsRecTableMixin.js'

export default {
    name: 'table-reposicion-config',
    mixins: [configsRecTableMixin],
    components: {
        inputSearch,
        Placeholder,
        PaginationControls,
    },
    props: {
        products: { type: Array, required: true, default: () => [] },
        loading: { type: Boolean, default: false },
        totalCount: { type: Number, default: 0 },
        currentPage: { type: Number, default: 1 },
        pageSize: { type: Number, default: 25 },
    },
    data() {
        return {
            search_product: '',
            search_type: 'codigo',
            tableConfigKey: 'replacement_cost'
        };
    },
    computed: {
        ...mapGetters(["authentication_user", "activeDesk"]),
        showCluster() {
            return this.authentication_user.active_store;
        },
        clientMoney() {
            return this.authentication_user.client_money || 'S/';
        },
    },
    methods: {
        formatCost(product) {
            let cost = product.cost_price;
            if (cost === null || cost === undefined || cost === '') return '0.00';
            return new Intl.NumberFormat("en-US", { maximumFractionDigits: 2 }).format(parseFloat(cost));
        },
        formatDate(dateStr) {
            if (!dateStr) return '—';
            let d;
            if (/^\d{2}-\d{2}-\d{4}/.test(dateStr)) {
                const [datePart, timePart = '00:00'] = dateStr.split(' ');
                const [day, month, year] = datePart.split('-');
                d = new Date(`${year}-${month}-${day}T${timePart}:00`);
            } else {
                d = new Date(dateStr);
            }
            if (isNaN(d.getTime())) return dateStr;
            return d.toLocaleDateString('es-PE', { day: '2-digit', month: '2-digit', year: 'numeric', hour: '2-digit', minute: '2-digit' }).replaceAll('/', '-');
        },
        getSearch(row) {
            this.$emit('getData', row.search, row.searchType);
        },
        viewConfig(row, name, title, text) {
            this.$emit('viewModal', row, name, title, text);
        },
    },
};
</script>

<style scoped>
.reposicion-config-card {
    background: #ffffff;
    border: 1px solid #e5e7eb;
    border-radius: 12px;
    padding: 24px;
    font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif;
}

.reposicion-header-row {
    display: flex;
    align-items: center;
    justify-content: space-between;
    flex-wrap: wrap;
    gap: 16px;
    margin-bottom: 1.25rem;
}

.reposicion-actions-row {
    display: flex;
    align-items: center;
    gap: 0.5rem;
    flex-wrap: wrap;
}

.reposicion-table-info-row {
    display: flex;
    justify-content: flex-end;
    align-items: center;
    margin-bottom: 0.5rem;
    margin-top: 0.25rem;
}

.reposicion-total-count {
    font-size: 0.85rem;
    font-weight: 600;
    color: #6b7280;
    white-space: nowrap;
}

.reposicion-action-search {
    flex: 1 1 250px;
    min-width: 0;
}

.reposicion-action-search :deep(.search-container-wrapper),
.reposicion-action-search ::v-deep .search-container-wrapper,
.reposicion-action-search /deep/ .search-container-wrapper {
    width: 100%;
    max-width: none;
}

.reposicion-action-search ::v-deep .search-wrapper,
.reposicion-action-search /deep/ .search-wrapper {
    width: 100%;
}

.reposicion-table {
    border-collapse: collapse;
    font-size: 0.85rem;
}

.reposicion-table thead th {
    text-align: left;
    font-size: 0.7rem;
    font-weight: 700;
    color: #9ca3af;
    letter-spacing: 0.03em;
    padding: 10px 12px;
    border-bottom: 1px solid #e5e7eb;
    white-space: nowrap;
    background-color: #F3F4F6;
}

.reposicion-table tbody td {
    padding: 12px;
    border-bottom: 1px solid #f3f4f6;
    vertical-align: middle;
    color: #1f2937;
}

.reposicion-table tbody tr:hover {
    background: #fafafa;
}

.reposicion-table thead th.editable-header {
    background-color: #E8F8F4;
    color: #087F6A;
    font-weight: 700;
}

.reposicion-table tbody td.col-highlight {
    background-color: #F8FCFB;
}

.reposicion-sku-badge {
    display: inline-block;
    background: #f3f4f6;
    color: #374151;
    font-size: 0.78rem;
    font-weight: 600;
    padding: 3px 8px;
    border-radius: 6px;
}

@media (max-width: 991.98px) {
    .reposicion-actions-row {
        display: grid;
        grid-template-columns: repeat(2, 1fr);
        gap: 0.5rem;
        width: 100%;
        align-items: stretch;
    }

    .reposicion-actions-row > * {
        box-sizing: border-box;
        min-width: 0;
        width: 100%;
    }

    .reposicion-actions-row .btn {
        width: 100%;
        display: inline-flex;
        align-items: center;
        justify-content: center;
    }
}
</style>
